module.exports = __webpack_public_path__ + "img/papers.5eb9cea3.svg";